import AvailableDomainBody from "components/availableDomainBody/AvailableDomainBody";
import Page from "components/page/Page";
import PageTitle from "components/pageTitle/PageTitle";
import PageWrapper from "components/pageWrapper/PageWrapper";
import PurchaseDropDown from "components/purchaseDropDown/PurchaseDropDown";
import TakenDomainBody from "components/takenDomainBody/TakenDomainBody";
import WhoisButton from "components/whoisButton/WhoisButton";
import { useAppDispatch, useAppSelector } from "hooks";
import { memo, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import domainSlice from "reducers/domainSlice";
import {
  domainDetailsSelector,
  getDomainDetailsErrorSelector,
  gettingDomainDetailsSelector,
  resellersSelector,
} from "selectors/domainSelectors";
import { RootState } from "store";
import { styled } from "styled-components";

const StyledPageTitle = styled(PageTitle)<{
  $registered: boolean;
  $loaded: boolean;
}>`
  flex: 1;
  margin-bottom: 0;
  color: ${(props: any) =>
    props.$loaded ? (props.$registered ? "#c60404" : "#21b400") : "#222222"};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 48px;
  margin-bottom: 10px;

  @media only screen and (max-width: 992px) {
    padding-top: 10px;
  }

  @media only screen and (max-width: 500px) {
    flex-direction: column;
    > div {
      margin-top: 20px;
      margin-bottom: 10px;
    }
  }
`;

const Status = styled.div``;

const SpinnerWrapper = styled.div`
  color: #28c604;
  font-size: initial;

  > div {
    font-size: 1.5rem;
    width: 30px;
    height: 30px;
  }
`;

const DomainPage = () => {
  const { domain } = useParams();

  const dispatch = useAppDispatch();

  const [records, setRecords] = useState<string[] | undefined>(undefined);

  useEffect(() => {
    if (domain) {
      dispatch(domainSlice.actions.getDomainDetails(domain));
    }
  }, [dispatch, domain]);

  const gettingDomainDetails = useAppSelector((state: RootState) =>
    gettingDomainDetailsSelector(state)
  );

  const domainDetails = useAppSelector((state: RootState) =>
    domainDetailsSelector(state)
  );

  const getDomainDetailsError = useAppSelector((state: RootState) =>
    getDomainDetailsErrorSelector(state)
  );

  const handleOnRecodsLoaded = (records: string[]) => {
    setRecords(records);
  };

  const resellers = useAppSelector((state: RootState) =>
    resellersSelector(state)
  );

  return (
    <>
      <Helmet>
        <title>Domain Findr - {domain}</title>
      </Helmet>
      <Page collapsedView={true} maxWidth={800}>
        <PageWrapper>
          <Header>
            <StyledPageTitle
              $registered={domainDetails?.registered ?? false}
              $loaded={
                gettingDomainDetails === false &&
                domainDetails?.registered !== undefined
              }
              align="left"
            >
              {domain}
            </StyledPageTitle>
            <Status>
              {gettingDomainDetails === true && (
                <SpinnerWrapper>
                  <Spinner size="sm" />
                </SpinnerWrapper>
              )}

              {domain && !gettingDomainDetails && domainDetails?.registered && (
                <WhoisButton
                  records={records}
                  name={domain}
                  onRecordsLoaded={handleOnRecodsLoaded}
                />
              )}
              {domain &&
                !gettingDomainDetails &&
                !domainDetails?.registered &&
                resellers && (
                  <PurchaseDropDown resellers={resellers} domain={domain} />
                )}
            </Status>
          </Header>
          {domain &&
            !gettingDomainDetails &&
            domainDetails &&
            !domainDetails?.registered && (
              <AvailableDomainBody domainDetails={domainDetails} />
            )}
          {domain &&
            !gettingDomainDetails &&
            domainDetails &&
            domainDetails?.registered && (
              <TakenDomainBody domainDetails={domainDetails} />
            )}
        </PageWrapper>
      </Page>
    </>
  );
};

export default memo(DomainPage);
